import axios from 'axios';
export function getHashFragment(state) {
    return axios.get(`/authn-callback/hash-fragment?state=` + state, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}
